/**
 * Menu —— 评论三点菜单组件
 *
 * 职责：管理菜单面板的开关状态，处理点击外部关闭逻辑。
 */
export class Menu {
  private isOpen = false;
  private menuPanel: HTMLElement | null;
  private toggleBtn: HTMLElement | null;
  private unbindOutsideClick: (() => void) | null = null;

  constructor(private element: HTMLElement) {
    this.menuPanel = element.querySelector("[data-menu-panel]");
    this.toggleBtn = element.querySelector("[data-menu-toggle]");

    this.init();
  }

  private init(): void {
    this.toggleBtn?.addEventListener("click", () => this.toggle());

    // 点击菜单内的链接后自动关闭菜单
    this.menuPanel?.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => this.close());
    });

    const handleOutsideClick = (e: MouseEvent) => {
      if (this.isOpen && !this.element.contains(e.target as Node)) {
        this.close();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    this.unbindOutsideClick = () =>
      document.removeEventListener("click", handleOutsideClick);
  }

  private toggle(): void {
    this.isOpen ? this.close() : this.open();
  }

  private open(): void {
    this.isOpen = true;
    if (this.menuPanel) this.menuPanel.style.display = "";
  }

  private close(): void {
    this.isOpen = false;
    if (this.menuPanel) this.menuPanel.style.display = "none";
  }

  destroy(): void {
    this.unbindOutsideClick?.();
  }

  /** 注册 Unpoly 编译器 */
  static compiler(selector: string): void {
    up.compiler(selector, (element: Element) => {
      const menu = new Menu(element as HTMLElement);
      return () => menu.destroy();
    });
  }
}
